// @flow
import { useSelector } from 'react-redux';
import { useTravellersLabel } from '../../../../../components/SearchForm/components/TravellersField/hooks/useTravellersLabel.js';
import { useTravellersLabelMultiroom } from '../../../../../components/SearchForm/components/TravellersFieldMultiroom/hooks/useTravellersLabelMultiroom.js';
import { useTravelDurationLabel } from '../../../../../components/SearchForm/components/TravelPeriodField/hooks/useTravelDurationLabel.js';
import { useTravelPeriodLabel } from '../../../../../components/SearchForm/components/TravelPeriodField/hooks/useTravelPeriodLabel.js';
import { searchFormSelectors } from '../../../../../components/SearchForm/redux/index.js';
export const useLabels = (defaultValues = {}, multiroom) => {
  const {
    destination,
    travelPeriod,
    travellers,
    travellersMultiroom
  } = useSelector(searchFormSelectors.getValues);
  const destinationLabel = destination?.keyword || undefined;
  const travelPeriodLabel = useTravelPeriodLabel({
    startDate: travelPeriod?.startDate ?? defaultValues.travelPeriod?.startDate,
    endDate: travelPeriod?.endDate ?? defaultValues.travelPeriod?.endDate,
    short: true
  });
  const travelDurationLabel = useTravelDurationLabel({
    minDuration: travelPeriod?.duration?.min ?? defaultValues.travelPeriod?.duration?.min,
    maxDuration: travelPeriod?.duration?.max ?? defaultValues.travelPeriod?.duration?.max
  });
  const travellersLabelMultiroom = useTravellersLabelMultiroom(travellersMultiroom ?? defaultValues?.travellersMultiroom);
  const travellersLabel = useTravellersLabel({
    adultCount: travellers?.adultCount ?? defaultValues.travellers?.adultCount,
    childrenCount: travellers?.childrenAges?.length ?? defaultValues.travellers?.childrenAges?.length ?? 0
  });
  return {
    destination: destinationLabel,
    travelPeriod: travelPeriodLabel,
    travelDuration: travelDurationLabel,
    travellers: multiroom ? travellersLabelMultiroom : travellersLabel
  };
};